module.exports = __webpack_public_path__ + "static/media/01_Maf_NuestroEquipo_DraFromow.c0d06ff1.jpg";